<template>
    <div v-if="!loadingContent">
        <froala 
            :tag="'textarea'" 
            :config="froalaConfig" 
            v-model="mensagem"
        ></froala>

       <!--  <froala 
            :tag="'textarea'" 
            :config="froalaConfig" 
            v-model="formData.conteudo" 
            :onManualControllerReady="initialize"
        ></froala> -->
        <!-- <froalaView v-model="formData.conteudo"></froalaView> -->
    </div>
</template>

<script>

  import Rest from 'common/rest'

  export default {
        name:"ckeditor",
        components:{},
        mixins:[Rest],

        props:{
            model:{
                type:String,
                default:function () { return null }
            },
            conteudo:{
                type:String,
                default:function () { return null }
            },

            reload:{
                type:Boolean,
                default:function () { return false }
            }
        },

        data () {
          return {
            loadingContent:true,
            urlRemove:[],
            initControls:null,
            deleteAll:null,
            mensagem:null,
            froalaConfig: {
                language: 'pt_br',
                placeholderText: "Escreva seu texto aqui",
                disableRightClick: true,
                key: process.env.FROALA_KEY,

                //IMAGE
                imageUploadParam: 'froala_image',
                imageUploadURL: '',
                imageUploadParams: {id: 'my_editor'},
                imageUploadMethod: 'POST',
                imageMaxSize: 5 * 1024 * 1024,
                imageAllowedTypes: ['jpeg', 'jpg', 'png'],
                requestHeaders: {},
                imageStyles: {
                    imageAddBorda: 'Adicionar Borda',
                },
                //IMAGE MANAGER
                //imageManagerPreloader: "/images/loader.gif",
                imageManagerPageSize: 20,
                imageManagerScrollOffset: 10,
                imageManagerLoadURL: "",
                imageManagerLoadMethod: "GET",
                imageManagerLoadParams: {user_id: 4219762},
                imageManagerDeleteURL: "",
                imageManagerDeleteMethod: "POST",
                imageManagerDeleteParams: {param: 'value'},
                toolbarButtons: [
                    'fullscreen', 
                    'bold', 
                    'italic', 
                    'underline', 
                    'strikeThrough', 
                    'subscript', 
                    'superscript', 
                    '|', 
                    'fontFamily', 
                    'fontSize', 
                    'color', 
                    'inlineStyle', 
                    'paragraphStyle', 
                    '|', 
                    'paragraphFormat', 
                    'align', 
                    'formatOL', 
                    'formatUL', 
                    'outdent', 
                    'indent', 
                    'quote', 
                    '-', 
                    'insertLink', 
                    //'insertImage', 
                    'embedly', 
                    //'insertVideo',
                    //'insertFile', 
                    'insertTable', 
                    '|', 
                    'emoticons', 
                    'specialCharacters', 
                    'insertHR', 
                    'selectAll', 
                    'clearFormatting', 
                    '|', 
                    'print', 
                    'spellChecker', 
                    'help', 
                    'html', 
                    '|', 
                    'undo', 
                    'redo'
                ],
                imageEditButtons: [
                    'imageReplace', 
                    'imageAlign', 
                    'imageRemove', 
                    '|', 
                    'imageLink', 
                    'linkOpen', 
                    'linkEdit', 
                    'linkRemove', 
                    '-', 
                    'imageDisplay', 
                    'imageStyle', 
                    'imageAlt', 
                    'imageSize'
                ],

                //EVENTS
                events: {

                    //IMAGE
                    // 'froalaEditor.initialized': this.initialized,
                    // 'froalaEditor.image.beforeUpload': this.imageBeforeUpload,
                    // 'froalaEditor.image.uploaded': this.imageUploaded,
                    // 'froalaEditor.image.inserted': this.imageInserted,
                    // 'froalaEditor.image.replaced': this.imageReplaced,
                    // 'froalaEditor.image.error': this.imageError,
                    // 'froalaEditor.image.beforeRemove': this.imageDeleted,

                    //IMAGE MANAGER
                    // 'froalaEditor.imageManager.error': this.imageError,
                    // 'froalaEditor.imageManager.imagesLoaded': this.imagesLoaded,
                    // 'froalaEditor.imageManager.imageLoaded': this.imageLoaded,
                    // 'froalaEditor.imageManager.beforeDeleteImage': this.beforeDeleteImage,
                    // 'froalaEditor.imageManager.imageDeleted': this.imageDeleted,
                },          
            }
          }
        },

        mounted() {
            this.init();
        },

        watch:{
            'conteudo'(){
                this.init();
            },
            'mensagem'(){
                this.setConteudo();
            },
            'model'(){
            },
            reload(){
                this.init();
            }
        },

        methods:{

            setConteudo(){
                this.$events.fire('ckeditor-'+this.model,this.mensagem);
            },

            init: function(){

                var config = Object.assign({},this.froalaConfig);

                //config.imageUploadURL = this.getUrlApi()+'froala/upload/image';
                //config.imageManagerLoadURL = this.getUrlApi()+'froala/load/image';
                //config.imageManagerDeleteURL = this.getUrlApi()+'froala/delete/image';

                //config.requestHeaders = this.getHeaders(true);

                this.froalaConfig = config;
                this.mensagem = this.conteudo;
                this.loadingContent = false;

                // if(this.initControls){
                //     this.initControls.initialize();
                // }

            },

            initialize: function(initControls) {

              this.initControls = initControls;
              this.deleteAll = () => {
                this.initControls.getEditor()('html.set', '');
                this.initControls.getEditor()('undo.reset');
                this.initControls.getEditor()('undo.saveStep');
              };

              this.initControls.initialize();
            },

            initialized: function(){
            },

            imageBeforeUpload: function(e, editor, files){
            },

            imageUploaded: function(e, editor, response){
            },

            imageInserted: function(e, editor, $img, response){
            },

            imageReplaced: function(e, editor, $img, response){
            },

            imagesLoaded: function(e, editor, data){
            },

            imageLoaded: function(e, editor, $img){
            },

            beforeDeleteImage: function(e, editor, $img){
            },

            imageDeleted: function(e, editor, data){
            },

            imageDeleted: function(e, editor, $img){

                var src = ($img[0] && $img[0]['currentSrc'] ? $img[0]['currentSrc'] : null);

                if(src){
                    this.post('froala/delete',{src:src}).then((result)=>{

                        result = result[0];
                        console.log(result)
                    });
                }
            },

            imageError: function(e, editor, error, response){
            }
        }
    }
</script>

<style lang="scss">
    .imageAddBorda {
        border: 2px solid #efefef;
    }
     
    .imageRemoveBorda {
        border: none;
    }
    .fr-active{
        z-index:99999 !important;
    }
    .fr-overlay{
        z-index:999 !important;
    }
    .fr-wrapper>div>a{ 
        /*display: none!important; */
    }
</style>


// WEBPACK FOOTER //
// ckeditor.vue?25d27815